import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { ConfigurationChangeModel, DocumentEncryptionConfigurationModel, DocumentEncryptionStatusModel } from '@/types';
import axios from 'axios';

const DocumentEncryptionConfiguration = 'documentEncryptionConfiguration';

export const DocumentEncryptionConfigurationService = {
  async beginChangeAsync(change: ConfigurationChangeModel): Promise<ConfigurationChangeModel> {
    const response = await axios.post(`${DocumentEncryptionConfiguration}/change`, change);
    return response.data;
  },
  async endChangeAsync(changeId: number): Promise<ConfigurationChangeModel> {
    const response = await axios.put(`${DocumentEncryptionConfiguration}/change/${changeId}`);
    return response.data;
  },
  async getDocumentEncryptionConfigurationAsync(): Promise<DocumentEncryptionConfigurationModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${DocumentEncryptionConfiguration}/settings`);
    return response.data;
  },
  async updateDocumentEncryptionConfigurationAsync(documentEncryptionConfigurationModel: DocumentEncryptionConfigurationModel) {
    const response = await axios.put(`${DocumentEncryptionConfiguration}/settings`, documentEncryptionConfigurationModel);
    return response.data;
  },
  async getDocumentEncryptionStatusAsync(): Promise<DocumentEncryptionStatusModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${DocumentEncryptionConfiguration}/status`);
    return response.data;
  }
};
